import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';

const NotFoundPage = () => {
  return (
    <motion.div
      className="flex flex-col items-center justify-center text-center w-full" // Removed min-h, px
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <motion.div
         initial={{ rotate: -10 }}
         animate={{ rotate: [0, 5, -5, 0] }}
         transition={{ duration: 0.8, repeat: Infinity, repeatType: "mirror" }}
      >
        <AlertTriangle className="h-24 w-24 text-destructive mb-6" />
      </motion.div>

      <motion.h1
        className="text-5xl md:text-7xl font-extrabold text-primary mb-4"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        404
      </motion.h1>
      <motion.p
        className="text-xl md:text-2xl font-semibold text-foreground mb-4"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        >
        Page Not Found
      </motion.p>
      <motion.p
        className="text-muted-foreground mb-8 max-w-md"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.5 }}
        >
        Oops! The page you're looking for doesn't seem to exist. It might have been moved or deleted.
      </motion.p>
      <motion.div
         initial={{ scale: 0.8, opacity: 0 }}
         animate={{ scale: 1, opacity: 1 }}
         transition={{ delay: 0.5, duration: 0.5 }}
      >
          <Button asChild size="lg">
            <Link to="/">
              <Home className="mr-2 h-5 w-5" />
              Go Back Home
            </Link>
          </Button>
      </motion.div>
    </motion.div>
  );
};

export default NotFoundPage;